<template>
  <BaseWorkPageLayout :title="$t('global.tasks')" icon="tasks">
    <template #default>
      <div class="flex flex-col gap-4">
        <!-- WorkTask-->
        <PageSection disable-sticky-margin :title="$t('global.tasks')">
          <ul
            v-if="work.work_tasks"
            role="list"
            class="grid grid-cols-[repeat(auto-fill,minmax(18rem,1fr))] gap-4"
          >
            <li
              v-for="(task, index) in work.work_tasks"
              :key="index"
              class="col-span-1 rounded-lg border-gray-300 bg-gradient-to-br from-gray-100 to-gray-50 shadow-md"
            >
              <WorkTaskCard
                :task="task"
                @click-openModal="clickTask"
                @openModal="openModal"
              />
            </li>
          </ul>
          <div v-else>
            {{
              $t('validation.there_is_no_for_m', {
                content: $t('global.task'),
                container: $t('global.work')
              })
            }}
          </div>
        </PageSection>

        <template v-for="type in this.metadata?.events?.event_type">
          <PageSection
            disable-sticky-margin
            v-if="
              work.events?.find((event) => event.type === type.id) &&
              work.events?.find((event) => event.type === type.id)?.work_tasks
                ?.length > 0
            "
            :title="$t('enums.event.type.' + type.id)"
          >
            <ul
              role="list"
              class="grid grid-cols-[repeat(auto-fill,minmax(18rem,1fr))] gap-4"
            >
              <li
                v-for="(task, index) in work.events?.find(
                  (event) => event.type === type.id
                ).work_tasks"
                :key="index"
                class="col-span-1 divide-y divide-gray-200 rounded-lg border-gray-300 bg-gradient-to-br from-gray-100 to-gray-50 shadow-md"
              >
                <WorkTaskCard
                  :task="task"
                  @click-openModal="clickTask"
                  @openModal="openModal"
                />
              </li>
            </ul>
          </PageSection>
        </template>
      </div>
    </template>
  </BaseWorkPageLayout>
  <WorkTaskFormDialog
    v-if="isModalVisible"
    ref="eventModal"
    :isModalVisible="isModalVisible['WorkTaskFormDialog']"
    :work-id="work.id"
    @openModal="openModal"
    @close="closeAllModals"
    @backdropClicked="closeAllModals"
  />

  <WorkTaskStatusChangeDialog
    @backdropClicked="closeAllModals"
    @close="closeAllModals"
    :is-modal-visible="isModalVisible['TaskFormDialog']"
    :form="selectedForm"
    :nextStatus="nextStatusToChange"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import WorkTaskCard from './components/WorkTaskCard'
import WorkTaskFormDialog from './components/WorkTaskFormDialog'
import WorkTaskStatusChangeDialog from '@p/works/form/subpages/tasks/components/WorkTaskStatusChangeDialog'

export default {
  name: 'TheWorkTasksPage',
  components: {
    WorkTaskCard,
    WorkTaskFormDialog,
    WorkTaskStatusChangeDialog
  },
  data() {
    return {
      isModalVisible: {
        WorkTaskFormDialog: false,
        TaskFormDialog: false
      },
      selectedTaskId: null,
      selectedForm: null,
      nextStatusToChange: null
    }
  },
  computed: {
    ...mapGetters({ work: 'work/getWork', metadata: 'work/getWorkMetadata' })
  },
  methods: {
    ...mapMutations({ setSelectedWorkTask: 'work/setSelectedWorkTask' }),
    clickTask({ workTask, modal }) {
      if (workTask) {
        console.log('click task')
        this.setSelectedWorkTask(workTask)
        this.isModalVisible[modal] = true
      }
    },
    openModal({ modal, task, form, nextStatus }) {
      console.log('open modal', form)
      console.log('ici', nextStatus)
      this.closeAllModals()
      this.setSelectedWorkTask(task)
      this.selectedForm = form
      this.nextStatusToChange = nextStatus
      this.isModalVisible[modal] = true
    },
    closeAllModals() {
      this.selectedTaskId = null
      for (const property in this.isModalVisible) {
        this.isModalVisible[property] = false
        this.setSelectedWorkTask({})
      }
    }
  }
}
</script>
